export default "__VITE_ASSET__DpwIuEy9__"